import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section"><inlineCode parentName="p">{`storeProjection`}</inlineCode>{` - String - Optional`}<br parentName="p"></br>{`
`}{`Key of an existing `}<a parentName="p" {...{
          "href": "/api/../api/projects/stores#store"
        }}>{`Store`}</a>{`.`}<br parentName="p"></br>{`
`}{`If the Store defines some languages, distribution channels or supply channels, they are used to enable `}<a parentName="p" {...{
          "href": "/api/../api/projects/productProjections#locales"
        }}>{`locale based projection`}</a>{`, `}<a parentName="p" {...{
          "href": "/api/../api/projects/productProjections#prices"
        }}>{`price based projection`}</a>{` and `}<a parentName="p" {...{
          "href": "/api/../api/projects/productProjections#inventory-entries"
        }}>{`inventory based projection`}</a>{` respectively.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      